import type { UserInfo } from 'hub-http/userInfo';

export const AUTOMATION_EMBEDDED_ACCESS = 'automation-embedded-access';

export const getUserHasEmbeddedAutomationAccess = (
  userInfo?: Partial<UserInfo>
) => userInfo?.user?.scopes?.includes(AUTOMATION_EMBEDDED_ACCESS) ?? false;
